export default __webpack_public_path__ + "static/media/s-42.d26287e4.svg";